import { render, staticRenderFns } from "./RiskDiagnosisList.vue?vue&type=template&id=bb5bb2ee"
import script from "./RiskDiagnosisList.vue?vue&type=script&lang=js"
export * from "./RiskDiagnosisList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports